import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProtectedRoute from "components/ProtectedRoute";
import { Login, Signup } from './pages/auth';
import PrivacyPolicy from './pages/privacy-policy';
import Surveys from './pages/surveys';
import Dashboard from './pages/dashboard';
import PropertyManagement from './pages/property-management';
import PropertyMaps from './pages/property-management/components/PropertyMaps';
import ClientManagement from './pages/client-management';
import ReportsAnalytics from './pages/reports-analytics';
import FieldSurvey from './pages/field-survey';
import FinanceTracker from './pages/finance-tracker';
import RoleManagement from './pages/role-management';
import ManageRoles from './pages/role-management/ManageRoles';
import AssignUserRole from './pages/role-management/AssignUserRole';
import CoordinatorClientAssignment from './pages/role-management/CoordinatorClientAssignment';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        
        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/surveys" element={
          <ProtectedRoute>
            <Surveys />
          </ProtectedRoute>
        } />
        <Route path="/property-management" element={
          <ProtectedRoute>
            <PropertyManagement />
          </ProtectedRoute>
        } />
        <Route path="/property-maps" element={
          <ProtectedRoute>
            <PropertyMaps />
          </ProtectedRoute>
        } />
        <Route path="/client-management" element={
          <ProtectedRoute>
            <ClientManagement />
          </ProtectedRoute>
        } />
        <Route path="/reports-analytics" element={
          <ProtectedRoute>
            <ReportsAnalytics />
          </ProtectedRoute>
        } />
        <Route path="/field-survey" element={
          <ProtectedRoute>
            <FieldSurvey />
          </ProtectedRoute>
        } />
        
        <Route path="/finance-tracker" element={
          <ProtectedRoute>
            <FinanceTracker />
          </ProtectedRoute>
        } />

        {/* Role Management */}
        <Route path="/role-management" element={
          <ProtectedRoute>
            <RoleManagement />
          </ProtectedRoute>
        } />
        <Route path="/role-management/manage-roles" element={
          <ProtectedRoute>
            <ManageRoles />
          </ProtectedRoute>
        } />
        <Route path="/role-management/assign-user-role" element={
          <ProtectedRoute>
            <AssignUserRole />
          </ProtectedRoute>
        } />
        <Route path="/role-management/coordinator-client-assignment" element={
          <ProtectedRoute>
            <CoordinatorClientAssignment />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
